import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NAV_ITEMS } from "@/config/navigation";
import { NavbarFlutuante } from "./NavbarFlutuante";

/* ── Route groups per tab ── */

const RECIPES_ROUTES: string[] = [
  "/recipes",
  "/reposteria-cero",
  "/create-recipe",
  "/my-recipes",
  "/coleccion",
  "/product",
];

const MORE_ROUTES: string[] = [
  "/more",
  "/profile",
  "/settings",
  "/feedback",
  "/shopping-list",
  "/saved-recipes",
  "/support",
  "/help",
  "/rate",
  "/my-content",
  "/clean-remedies",
];

const GLUCOPHOTO_ROUTES: string[] = ["/glucophoto"];

/** Check whether the current path belongs to a tab's route group */
const matchesGroup = (pathname: string, routes: string[]): boolean =>
  routes.some((r) => pathname === r || pathname.startsWith(r + "/"));

/**
 * As quatro abas do app. Montada UMA vez, no Chrome, fora das telas: a
 * navbar não some nem pisca quando a tela troca.
 */
const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const p = location.pathname;

  // Hide on cooking mode, login, and the recipe detail screen itself —
  // a focus screen on mobile, matching how cooking mode already hides it.
  const isCooking = p.endsWith("/cooking");
  const isLogin = p === "/login";
  const isFeedbackThread = /^\/feedback\/[^/]+$/.test(p) && p !== "/feedback";
  const isRecipeDetail = /^\/recipes\/[^/]+\/[^/]+$/.test(p) || /^\/my-recipes\/[^/]+$/.test(p);
  if (isCooking || isLogin || isFeedbackThread || isRecipeDetail) return null;

  const isActiveItem = (key: string) => {
    switch (key) {
      case "home":       return p === "/" || p === "/home";
      case "recipes":    return matchesGroup(p, RECIPES_ROUTES);
      case "glucophoto": return matchesGroup(p, GLUCOPHOTO_ROUTES);
      case "more":       return matchesGroup(p, MORE_ROUTES);
      default:           return false;
    }
  };

  const abas = NAV_ITEMS.map((item) => ({
    key: item.key,
    icon: item.icon,
    label: item.i18nKey ? t(item.i18nKey, item.label) : item.label,
    // BottomNav routes to "/" for home; override path accordingly
    path: item.key === "home" ? "/" : item.path,
  }));
  const ativa = NAV_ITEMS.findIndex((item) => isActiveItem(item.key));

  return <NavbarFlutuante abas={abas} ativa={ativa} aoEscolher={(aba) => navigate(aba.path)} />;
};

export default BottomNav;
